module.exports = __webpack_public_path__ + "assets/img/f9213af4f08d403263fb581790931172.png";